import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "50",
  viewBox: "0 0 50 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M25 50C11.23 50 0 38.77 0 25S11.23 0 25 0c15.447 0 25 13.008 25 25 0 13.77-11.23 25-25 25zm1.982-20.833c0-.813.71-1.575 1.93-2.693 1.627-1.525 3.862-3.66 3.862-7.317 0-4.472-3.86-6.86-7.47-6.86-2.133 0-4.115.762-5.538 2.134-1.168 1.12-2.54 3.156-2.54 6.56h3.557c0-1.677.508-3.05 1.473-3.963.813-.763 1.93-1.17 3.1-1.17 1.88 0 3.912 1.017 3.912 3.304 0 2.134-1.27 3.303-2.744 4.725-1.422 1.372-3.048 2.897-3.048 5.285v2.59h3.557v-2.59zm-.204 5.183h-3.556v3.608h3.556z"
  })]
});